// extracted by mini-css-extract-plugin
export default {"button":"customButton_button__Am3Db"};